import React, { useState } from 'react';
import { LeadsTab } from './LeadsTab';
import { EnrollmentTab } from './EnrollmentTab';
import { MailingTab } from './MailingTab';
import { Globe } from 'lucide-react';

type TabType = 'leads' | 'enrollment' | 'mailing' | 'website';

export function MarketingPage() {
  const [activeTab, setActiveTab] = useState<TabType>('leads');

  const tabs: { id: TabType; label: string }[] = [
    { id: 'leads', label: 'Leads' },
    { id: 'enrollment', label: 'Enrollment' },
    { id: 'mailing', label: 'Mailing' },
    { id: 'website', label: 'My Website' },
  ];

  return (
    <div className="min-h-full">
      {/* Header */}
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Marketing</h1>
        <p className="text-sm text-gray-500">Administrator Platform</p>
      </div>

      {/* Tabs */}
      <div className="mb-6 border-b border-gray-200">
        <nav className="flex gap-8" aria-label="Tabs">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`pb-4 text-sm font-medium transition-colors relative ${
                activeTab === tab.id
                  ? 'text-teal-600 border-b-2 border-teal-600'
                  : 'text-gray-500 hover:text-gray-700'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      {/* Tab Content */}
      <div>
        {activeTab === 'leads' && <LeadsTab />}
        {activeTab === 'enrollment' && <EnrollmentTab />}
        {activeTab === 'mailing' && <MailingTab />}
        {activeTab === 'website' && <WebsitePlaceholder />}
      </div>
    </div>
  );
}

function WebsitePlaceholder() {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-gray-500">
      <Globe className="w-16 h-16 mb-4 opacity-30" />
      <h3 className="text-lg font-medium mb-2">My Website</h3>
      <p className="text-sm">Website builder and management coming soon</p>
    </div>
  );
}

export default MarketingPage;
